import styled from 'styled-components'
import CommonButton from 'components/Button/CommonButton'
import { WhiteBlock } from 'components/Layout'

export const JobNotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const JobNotesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const JobNotesAddButton = styled(CommonButton)`
  height: 40px;
  background: transparent;
`

export const JobNoteBlock = styled(WhiteBlock)`
  justify-content: center;
  align-items: center;
  padding: 20px 16px 16px;
  min-height: 100px;
`
